var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('post-header',{staticClass:"post-header",attrs:{"post":_vm.post}}),_c('post-body',{attrs:{"post":_vm.post,"isRepost":false},on:{"setTrust":_vm.setTrust}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }